import type {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T324041-homepage-redesign-logged-out-v3': 'control',
  'T338626-find-redesign': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'MQT-T342477-llm-directory-search-noop': 'control',
  'T336775-surface-language-matched-bids': 'control',
  'MQT-T329203-llm-bid-search-with-filter-extraction-v2': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T90189-image-thumbnail-service': 'control',
  webapp_playground_test: 'control',
  'T195472-web-push-notifications': 'control',
  'T281208-group-search-by-name': 'control',
  'T322080-prompt-2fa-upsell-noop': 'control',
  'T311153-only-show-recurable-payment-methods-for-monthly-membership':
    'Control',
  'T314575-pjp-email-and-phone-verify-redesign-v5': 'control',
  'T334915-pjp-email-phone-verify-redesign-for-paid-projects-v2': 'control',
  'T331317-indian-mandate-membership': 'control',
  'T332502-navigation-tabs': 'control',
  'T333761-messaging-redesign': 'test',
  'T331680-google-pay-rollout-v2': 'control',
  'T333835-extend-apple-pay-to-non-apple-browser-or-os-v2-noop': 'control',
  'T340796-disable-future-paypal-noop': 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
